<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-select v-model="query.bookId" size="small" style="width: 158px" placeholder="请选择科目">
                        <el-option v-for="item in bookList" :key="item.id" :label="item.bookName"
                                   :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="query.title"
                              placeholder="请输入处方名称"
                              suffix-icon="el-icon-search"
                              style="width: 260px;margin-left: 20px"
                              size="small">
                    </el-input>
                </div>
                <div>
                    <el-button type="primary" @click="addPrescribe" style="width: 124px;">新增处方大全</el-button>
                </div>
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '10%'}"
                          :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="title" label="处方名称"></el-table-column>
                    <el-table-column prop="bookName" label="科目"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" style="margin-right: 10px" @click="editPrescribe(scope.row)">编辑
                            </el-button>
                            <el-button type="text" class="delete-button" @click="deletePrescribe(scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-drawer title="新增处方大全" :visible.sync="dialogAddVisible" size="860px" :before-close="cancelAdd">
            <div class="drawer">
                <el-scrollbar style="height:100%">
                    <div style="padding: 20px 10px 0;">
                        <el-form :model="prescribeAdd" size="small" label-width="90px" ref="add" :rules="rule">
                            <el-form-item label="处方科目:" prop="medicineBookId">
                                <el-select v-model="prescribeAdd.medicineBookId" size="small" style="width: 282px">
                                    <el-option v-for="item in bookList" :key="item.id" :label="item.bookName"
                                               :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="处方名称:" prop="title">
                                <el-input v-model="prescribeAdd.title" style="width: 282px"></el-input>
                            </el-form-item>
                            <el-form-item label="主治:" prop="application">
                                <el-input v-model="prescribeAdd.application" type="textarea"
                                          style="width: 282px"></el-input>
                            </el-form-item>
                            <el-form-item label="处方用法:" prop="usage1">
                                <el-input v-model="prescribeAdd.usage1" type="textarea"
                                          style="width: 282px"></el-input>
                            </el-form-item>
                            <el-form-item label="搜索药材:" prop="searchIngredients">
                                <el-autocomplete
                                        style="width: 282px;"
                                        suffix-icon="el-icon-search"
                                        size="small"
                                        class="inline-input mr20"
                                        v-model="searchIngredients"
                                        :fetch-suggestions="querySearch"
                                        placeholder="请输入药材名称进行搜索"
                                        :trigger-on-focus="false"
                                        @select="addSelect"
                                ></el-autocomplete>
                            </el-form-item>
                            <div style="padding: 0 20px">
                                <el-table :data="prescribeAdd.medicineList"
                                          :header-cell-style="{'padding-left': '3%'}"
                                          :cell-style="{'padding-left': '3%'}">
                                    <el-table-column prop="medicineName" label="药材名称"></el-table-column>
                                    <el-table-column label="剂量(克)">
                                        <template slot-scope="scope">
                                            <el-form :model="scope.row" :rules="rule" ref="edit">
                                                <el-form-item prop="number">
                                                    <el-input type="number" style="width: 100px" @keydown="handleInput" size="small" v-model.number="scope.row.number"
                                                              　></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="text" class="delete-button"
                                                       @click="deleteIngredients(scope.$index)">删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form>
                    </div>

                </el-scrollbar>
            </div>
            <div class="dialog-foot-bottom">
                <el-button @click="cancelAdd" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px">确定</el-button>
            </div>
        </el-drawer>
        <el-drawer title="编辑处方" :visible.sync="dialogEditVisible" size="860px">
            <div class="drawer">
                <el-scrollbar style="height:100%">
                    <div style="padding: 20px 10px 0;">
                        <el-form :model="prescribeEdit" size="small" label-width="90px" ref="edit" :rules="rule">
                            <el-form-item label="处方科目:" prop="bookId">
                                <el-select v-model="prescribeEdit.medicineBookId" size="small" style="width: 282px">
                                    <el-option v-for="item in bookList" :key="item.id" :label="item.bookName"
                                               :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="处方名称:" prop="title">
                                <el-input v-model="prescribeEdit.title" style="width: 282px"></el-input>
                            </el-form-item>
                            <el-form-item label="主治:" prop="application">
                                <el-input v-model="prescribeEdit.application" type="textarea"
                                          style="width: 282px"></el-input>
                            </el-form-item>
                            <el-form-item label="处方用法:" prop="usage1">
                                <el-input v-model="prescribeEdit.usage1" type="textarea"
                                          style="width: 282px"></el-input>
                            </el-form-item>
                            <el-form-item label="搜索药材:" prop="searchIngredients">
                                <el-autocomplete
                                        style="width: 282px;"
                                        suffix-icon="el-icon-search"
                                        size="small"
                                        class="inline-input mr20"
                                        v-model="searchIngredients"
                                        :fetch-suggestions="querySearch"
                                        placeholder="请输入药材名称进行搜索"
                                        :trigger-on-focus="false"
                                        @select="editSelect"
                                ></el-autocomplete>
                            </el-form-item>
                            <div style="padding: 0 20px">
                                <el-table :data="prescribeEdit.bookRecipeList"
                                          :header-cell-style="{'padding-left': '3%'}"
                                          :cell-style="{'padding-left': '3%'}">
                                    <el-table-column prop="medicineName" label="药材名称"></el-table-column>
                                    <el-table-column label="剂量(克)">
                                        <template slot-scope="scope">
                                            <el-form :model="scope.row" :rules="rule" ref="edit">
                                                <el-form-item prop="count">
                                                    <el-input type="number" style="width: 100px" @keydown="handleInput" size="small" v-model.number="scope.row.number"
                                                              　></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <el-button type="text" class="delete-button"
                                                       @click="editDeleteIngredients(scope.$index)">删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form>
                    </div>
                </el-scrollbar>
            </div>
            <div class="dialog-foot-bottom">
                <el-button @click="dialogEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px">确定</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>

    export default {
        data: function () {
            return {
                authorization: localStorage.getItem('authorization'),
                // 表格信息
                query: {
                    bookId: '',
                    title: '',
                },
                bookList: [],
                loading: true,
                tableData: [],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                // 弹窗开关
                dialogAddVisible: false,
                dialogEditVisible: false,
                // 药材数据
                medicineList: [],
                searchIngredients: '',
                // 新增处方数据
                prescribeAdd: {
                    bookName:'',
                    id: '',
                    medicineBookId:'',
                    title: '',
                    application: '',
                    usage1: '',
                    bookRecipeList: [],
                    typeCode:''
                },
                rule: {
                    medicineBookId: [{required: true, message: '请选择处方科目', trigger: 'change'}],
                    title: [{required: true, message: '请输入处方名称', trigger: 'blur'}],

                },
                // 编辑处方数据
                prescribeEdit: {
                    bookName:'',
                    id: '',
                    medicineBookId:'',
                    title: '',
                    application: '',
                    usage1: '',
                    bookRecipeList: [],
                    typeCode:''
                },
            }
        },
        methods: {
            handleInput(e) {
                let a = e.key.replace(/[^\d]/g, "");
                if (!a) {
                    e.preventDefault();
                }
            },
            // 获取处方科目
            getSubject() {
                this.axios.get('/api-b/10005/queryMedicineBook?currentPage=1&pageSize=40', {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {

                    if (res.data.code === 10000) {
                        this.bookList = res.data.data.data
                        let all = {
                            id: '',
                            bookName: '全部'
                        }
                        this.bookList.unshift(all)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取处方列表
            getData() {
                this.loading = true
                let params = new FormData();
                params.append("medicineBookId", this.query.bookId)
                params.append("currentPage", this.pageNum)
                params.append("pageSize", this.pageSize)
                params.append("title", this.query.title)
                this.axios.post('/api-b/10005/queryMedicineBookDetail', params, {
                    headers: {
                        Authorization: this.authorization,
                    }
                }).then(res => {
                    console.log(res)
                    if (res.data.code === 10000) {
                        if (res.data.data.data !== null) {
                            let data = res.data.data.data
                            setTimeout(() => {
                                for (let i = 0; i < data.length; i++) {
                                    data[i].bookName = this.bookList.find(item => {
                                        return data[i].medicineBookId === item.id
                                    }).bookName
                                }
                                this.tableData = data
                            }, 300)
                        } else {
                            this.$message.info('暂无处方')
                            this.tableData = []
                        }
                        this.total = res.data.data.totalCount
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(() => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                this.getData();
            },
            // 打开新增弹窗
            addPrescribe() {
                this.dialogAddVisible = true
                this.searchIngredients = ''
                this.getSubject()
            },
            // 搜索药材提示
            querySearch(queryString, cb) {
                let params = new FormData()
                params.append('medicinalName', this.searchIngredients)
                params.append('pharmacyId', 0)
                params.append('typeCode', 'KE_LI')
                params.append('currentPage', 1)
                params.append('pageSize', 10)
                this.axios.post('api-b/10005/queryMedicinalMaterialsDisNew', params, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.data !== 0) {
                            this.medicineList = []
                            for (let i = 0; i < res.data.data.data.length; i++) {
                                this.medicineList[i] = {
                                    value: res.data.data.data[i].medicinalName,
                                    medicinalName: res.data.data.data[i].medicinalName
                                }
                            }
                        } else {
                            this.$message.info('暂无药材')
                            this.medicineList = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.medicineList = []
                    }
                    cb(this.medicineList);
                })
            },
            // 新增弹窗新增药材
            addSelect(item) {
                let medicine = {
                    medicineName: item.medicinalName,
                    number: '',
                }
                for (let i of this.prescribeAdd.medicineList) {
                    if (i.medicineName === item.medicinalName) {
                        this.$message.info("请勿重复添加");
                        this.searchIngredients = ''
                        return
                    }
                }
                this.prescribeAdd.bookRecipeList.push(medicine)
                this.searchIngredients = ''
            },
            // 新增弹窗删除药材
            deleteIngredients(index) {
                this.prescribeAdd.bookRecipeList.splice(index, 1)
            },
            cancelAdd() {
                this.dialogAddVisible = false
                this.$nextTick(() => {
                    this.$refs.add.resetFields()
                })
            },
            // 确认添加处方
            confirmAdd() {
                this.$refs.add.validate(valid => {
                    if (valid) {
                        let params = {
                            medicineBookId: this.prescribeAdd.medicineBookId,
                            title: this.prescribeAdd.title,
                            application: this.prescribeAdd.application,
                            usage1: this.prescribeAdd.usage1,
                            medicineList: this.prescribeAdd.bookRecipeList,
                        }
                        this.axios.post('/api-b/10030/100079', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogAddVisible = false
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.add.resetFields()
                                    this.prescribeAdd.bookRecipeList = []
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },

            // 编辑弹窗按钮
            editPrescribe(data) {
                this.searchIngredients = ''
                this.prescribeEdit.bookRecipeList = []
                this.searchIngredients = ''
                this.prescribeEdit = JSON.parse(JSON.stringify(data))
                this.dialogEditVisible = true

            },
            // 编辑弹窗增加药材
            editSelect(item) {
                let medicine = {
                    medicineName: item.medicinalName,
                    number: '',
                }
                this.prescribeEdit.bookRecipeList.push(medicine)
            },
            // 编辑弹窗删除药材
            editDeleteIngredients(index) {
                this.prescribeEdit.bookRecipeList.splice(index, 1)
            },
            confirmEdit() {
                this.$refs.edit.validate(valid => {
                    if (valid) {
                        let params = {
                            id: this.prescribeEdit.id,
                            medicineBookId: this.prescribeEdit.medicineBookId,
                            title: this.prescribeEdit.title,
                            application: this.prescribeEdit.application,
                            usage1: this.prescribeEdit.usage1,
                            medicineList: this.prescribeEdit.medicineList,
                        }
                        this.axios.put('/api-b/10030/100081', params, {
                            headers: {
                                Authorization: this.authorization
                            }
                        }).then(res => {
                            if (res.data.code === 10000) {
                                this.$message.success(res.data.message)
                                this.dialogEditVisible = false
                                this.getData()
                                this.$nextTick(() => {
                                    this.$refs.edit.resetFields()
                                    this.prescribeEdit.bookRecipeList = []
                                })
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    } else {
                        this.$message.error('请按照要求正确填写相关信息')
                    }
                })
            },
            // 删除处方
            deletePrescribe(data) {
                this.axios.delete('/api-b/10030/100080/' + data.detailId, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.getData()
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.error((res.data.message))
                    }
                })
            }
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep: true
            }
        },
        created() {
            this.getSubject()
            this.getData()
        }
    }
</script>

<style>
    :focus {
        outline: none;
    }

    .el-drawer__header > :first-child {
        margin-top: -20px;
    }

    .el-drawer__header {
        height: 34px;
        background: rgba(97, 167, 255, 1);
        margin-bottom: 0;
        color: #FFFFFF;
        font-size: 14px;
    }

    .el-drawer__close-btn {
        margin-top: -20px;
        color: #FFFFFF;
        font-size: 14px;
    }

    .el-scrollbar {
        padding-bottom: 20px;
    }

    body .el-scrollbar__wrap {
        overflow-x: hidden;
        margin-bottom: 20px;
    }

    .add-dialog {
        margin: 0 !important;
        position: absolute;
        right: 0;
        top: 0;
        min-width: 900px !important;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }

    .el-dialog__body {
        transform: translate3d(0, 0, 0);
        overflow: auto;
    }

    .dialog-foot-bottom {
        position: absolute;
        bottom: 20px;
        right: 20px;
    }
</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }

    .drawer {
        height: 861px;
        border-bottom: 1px solid rgba(227, 227, 227, 1);
    }

    .dialog-foot-bottom {
        position: absolute;
        bottom: 13px;
        right: 20px;
    }

    .delete-button {
        color: rgba(255, 75, 75, 1) !important;
    }

    .delete-button:hover {
        color: rgba(255, 75, 75, 0.8) !important;
    }

    .delete-button:focus {
        color: rgba(215, 37, 41, 1) !important;
    }
</style>